<template>
    <div
        class="alert px-4 py-2 rounded-lg bg-red-50 flex items-center justify-between"
        v-if="member.connection_status === 'CHALLENGED'"
    >
        <div class="flex items-center gap-3">
            <Icon icon="circle-x" class="w-5 h-5 text-red-500" pathClass="" />
            <p class="text-sm text-slate-800 font-normal">
                Institution connection was challenged
            </p>
        </div>
        <button
            v-if="canManage"
            class="px-4 py-1.5 bg-white dark:bg-slate-800 rounded shadow dark:shadow-slate-900/50 text-sm font-medium hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors border border-slate-200 dark:border-slate-700 text-slate-800 dark:text-slate-100 leading-tight h-9"
            @click="setShowChallengeModal(true, member)"
        >
            Resolve
        </button>
    </div>

    <div
        class="alert px-4 py-2 rounded-lg bg-red-50 flex items-center justify-between"
        v-if="member.connection_status === 'REJECTED'"
    >
        <div class="flex items-center gap-3">
            <Icon icon="circle-x" class="w-5 h-5 text-red-500" pathClass="" />
            <p class="text-sm text-slate-800 font-normal">
                Connection was rejected
            </p>
        </div>
        <button
            v-if="canManage"
            class="px-4 py-1.5 bg-white dark:bg-slate-800 rounded shadow dark:shadow-slate-900/50 text-sm font-medium hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors border border-slate-200 dark:border-slate-700 text-slate-800 dark:text-slate-100 leading-tight h-9"
            @click="setShowConnectModal(true, member, 'memberRequest')"
        >
            Resolve
        </button>
    </div>

    <div
        class="alert px-4 py-2 rounded-lg bg-red-50 flex items-center justify-between"
        v-if="member.connection_status === 'EXPIRED'"
    >
        <div class="flex items-center gap-3">
            <Icon icon="circle-x" class="w-5 h-5 text-red-500" pathClass="" />
            <p class="text-sm text-slate-800 font-normal">
                Connection has expired. Please try to reconnect.
            </p>
        </div>
        <button
            v-if="canManage"
            class="px-4 py-1.5 bg-white dark:bg-slate-800 rounded shadow dark:shadow-slate-900/50 text-sm font-medium hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors border border-slate-200 dark:border-slate-700 text-slate-800 dark:text-slate-100 leading-tight h-9"
            @click="setShowConnectModal(true, member, 'memberRequest')"
        >
            Resolve
        </button>
    </div>

    <div
        class="alert px-4 py-2 rounded-lg bg-red-50 flex items-center justify-between"
        v-if="member.connection_status === 'DENIED'"
    >
        <div class="flex items-center gap-3">
            <Icon icon="circle-x" class="w-5 h-5 text-red-500" pathClass="" />
            <p class="text-sm text-slate-800 font-normal">
                Connection was denied
            </p>
        </div>
        <button
            v-if="canManage"
            class="px-4 py-1.5 bg-white dark:bg-slate-800 rounded shadow dark:shadow-slate-900/50 text-sm font-medium hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors border border-slate-200 dark:border-slate-700 text-slate-800 dark:text-slate-100 leading-tight h-9"
            @click="setShowConnectModal(true, member, 'memberRequest')"
        >
            Resolve
        </button>
    </div>

    <div
        class="alert px-4 py-2 rounded-lg bg-red-50 flex items-center justify-between"
        v-if="member.connection_status === 'FAILED'"
    >
        <div class="flex items-center gap-3">
            <Icon icon="circle-x" class="w-5 h-5 text-red-500" pathClass="" />
            <p class="text-sm text-slate-800 font-normal">
                Connection failed. Please attempt to reconnect this account.
            </p>
        </div>
        <button
            v-if="canManage"
            class="px-4 py-1.5 bg-white dark:bg-slate-800 rounded shadow dark:shadow-slate-900/50 text-sm font-medium hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors border border-slate-200 dark:border-slate-700 text-slate-800 dark:text-slate-100 leading-tight h-9"
            @click="setShowConnectModal(true, member, 'memberRequest')"
        >
            Resolve
        </button>
    </div>

    <div
        class="alert px-4 py-2 rounded-lg bg-red-50 flex items-center justify-between"
        v-if="member.connection_status === 'DISCONNECTED'"
    >
        <div class="flex items-center gap-3">
            <Icon icon="circle-x" class="w-5 h-5 text-red-500" pathClass="" />
            <p class="text-sm text-slate-800 font-normal">
                Connection disconnected
            </p>
        </div>
        <button
            v-if="canManage"
            class="px-4 py-1.5 bg-white dark:bg-slate-800 rounded shadow dark:shadow-slate-900/50 text-sm font-medium hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors border border-slate-200 dark:border-slate-700 text-slate-800 dark:text-slate-100 leading-tight h-9"
            @click="setShowConnectModal(true, member, 'memberRequest')"
        >
            Resolve
        </button>
    </div>

    <div
        class="alert px-4 py-2 rounded-lg bg-red-50 flex items-center justify-between"
        v-if="member.connection_status === 'LOCKED'"
    >
        <div class="flex items-center gap-3">
            <Icon icon="circle-x" class="w-5 h-5 text-red-500" pathClass="" />
            <p class="text-sm text-slate-800 font-normal">
                Your account is locked. Please log in to the appropriate website
                and follow the steps to resolve the issue.
            </p>
        </div>
    </div>

    <div
        class="alert px-4 py-2 rounded-lg bg-red-50 flex items-center justify-between"
        v-if="member.connection_status === 'PREVENTED'"
    >
        <div class="flex items-center gap-3">
            <Icon icon="circle-x" class="w-5 h-5 text-red-500" pathClass="" />
            <p class="text-sm text-slate-800 font-normal">
                The last 3 attempts to connect have failed. Please re-enter your
                credentials to continue importing data.
            </p>
        </div>
        <button
            v-if="canManage"
            class="px-4 py-1.5 bg-white dark:bg-slate-800 rounded shadow dark:shadow-slate-900/50 text-sm font-medium hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors border border-slate-200 dark:border-slate-700 text-slate-800 dark:text-slate-100 leading-tight h-9"
            @click="setShowConnectModal(true, member, 'memberRequest')"
        >
            Resolve
        </button>
    </div>

    <div
        class="alert px-4 py-2 rounded-lg bg-red-50 flex items-center justify-between"
        v-if="member.connection_status === 'IMPEDED'"
    >
        <div class="flex items-center gap-3">
            <Icon icon="circle-x" class="w-5 h-5 text-red-500" pathClass="" />
            <p class="text-sm text-slate-800 font-normal">
                Your attention is needed at this institution's website. Please
                log in to the appropriate website and follow the steps to
                resolve the issue.
            </p>
        </div>
    </div>

    <div
        class="alert px-4 py-2 rounded-lg bg-red-50 flex items-center justify-between"
        v-if="member.connection_status === 'DEGRADED'"
    >
        <div class="flex items-center gap-3">
            <Icon icon="circle-x" class="w-5 h-5 text-red-500" pathClass="" />
            <p class="text-sm text-slate-800 font-normal">
                We are upgrading this connection. Please try again later.
            </p>
        </div>
    </div>

    <div
        class="alert px-4 py-2 rounded-lg bg-red-50 flex items-center justify-between"
        v-if="member.connection_status === 'DISCONTINUED'"
    >
        <div class="flex items-center gap-3">
            <Icon icon="circle-x" class="w-5 h-5 text-red-500" pathClass="" />
            <p class="text-sm text-slate-800 font-normal">
                Connections to this institution are no longer supported.
            </p>
        </div>
    </div>

    <div
        class="alert px-4 py-2 rounded-lg bg-red-50 flex items-center justify-between"
        v-if="member.connection_status === 'CLOSED'"
    >
        <div class="flex items-center gap-3">
            <Icon icon="circle-x" class="w-5 h-5 text-red-500" pathClass="" />
            <p class="text-sm text-slate-800 font-normal">
                This connection has been closed. You may track this account
                manually. If reopened, you may connect the institution again.
            </p>
        </div>
    </div>

    <div
        class="alert px-4 py-2 rounded-lg bg-red-50 flex items-center justify-between"
        v-if="member.connection_status === 'DISABLED'"
    >
        <div class="flex items-center gap-3">
            <Icon icon="circle-x" class="w-5 h-5 text-red-500" pathClass="" />
            <p class="text-sm text-slate-800 font-normal">
                Importing data from this institution has been disabled. Please
                contact us if you believe it has been disabled in error.
            </p>
        </div>
    </div>

    <div
        class="alert px-4 py-2 rounded-lg bg-red-50 flex items-center justify-between"
        v-if="member.connection_status === 'IMPAIRED'"
    >
        <div class="flex items-center gap-3">
            <Icon icon="circle-x" class="w-5 h-5 text-red-500" pathClass="" />
            <p class="text-sm text-slate-800 font-normal">
                You must re-authenticate before your data can be imported.
            </p>
        </div>
        <button
            v-if="canManage"
            class="px-4 py-1.5 bg-white dark:bg-slate-800 rounded shadow dark:shadow-slate-900/50 text-sm font-medium hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors border border-slate-200 dark:border-slate-700 text-slate-800 dark:text-slate-100 leading-tight h-9"
            @click="setShowConnectModal(true, member, 'memberRequest')"
        >
            Resolve
        </button>
    </div>
</template>

<script>
import { mapActions } from 'pinia';
import { useMembersStore } from '@/store/members';
import Icon from '@/components/ui/icon/icon.vue';

export default {
    components: {
        Icon,
    },
    props: {
        member: {
            type: Object,
            required: true,
        },
        // Whether the current user owns this connection. Defaults to false so the
        // safe (read-only) state applies if the flag is ever missing (SUPPORT-626).
        canManage: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        hasError() {
            if (
                this.member.connection_status === 'CHALLENGED' ||
                this.member.connection_status === 'REJECTED' ||
                this.member.connection_status === 'EXPIRED' ||
                this.member.connection_status === 'DENIED' ||
                this.member.connection_status === 'FAILED' ||
                this.member.connection_status === 'DISCONNECTED' ||
                this.member.connection_status === 'IMPAIRED' ||
                this.member.connection_status === 'LOCKED' ||
                this.member.connection_status === 'PREVENTED' ||
                this.member.connection_status === 'IMPEDED' ||
                this.member.connection_status === 'DEGRADED' ||
                this.member.connection_status === 'DISCONTINUED' ||
                this.member.connection_status === 'CLOSED' ||
                this.member.connection_status === 'DISABLED'
            ) {
                return true;
            }

            return false;
        },
    },
    data() {
        return {};
    },
    methods: {
        ...mapActions(useMembersStore, [
            'setShowChallengeModal',
            'setShowConnectModal',
        ]),
    },
    mounted() {},
};
</script>
